import { useTranslations } from 'next-intl';
import { debounce } from '@cat-ecom/common/utils/commonUtils';
import { CatHeading } from 'components/blocks-components';
import { MyEquipmentSearch, useBreakpoint } from 'components/pcc-components';
import { useMyEquipmentContext } from 'components/my-equipment/my-equipment-search-pagination-context';
import {AddEquipmentButton} from 'components/my-equipment/add-equipment-button';
import { DEBOUNCE_TIME_MILLISECONDS, PAGE_BREAKPOINTS } from 'constants/common';
import styles from './my-equipment-search-container.module.scss';

const MyEquipmentSearchContainer = () => {
  const t = useTranslations();
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.XL);
  const { searchValue, onSearch, selectedEquipmentIndex } =
    useMyEquipmentContext();
  const btnSize = isDesktop ? 'md' : 'sm';
  const btnText = isDesktop ? t('MEQ_ADD_EQUIP') : t('ADD')
  const isSelectedEquipment = selectedEquipmentIndex > -1;
  const handleSearch = debounce((searchTerm: string) => {
    onSearch(searchTerm);
  }, DEBOUNCE_TIME_MILLISECONDS);

  return (
    <div className={styles['equipment-header__container']}>
      <div className={styles['equipment-header__wrapper']}>
        <div className={`${styles['equipment-header__title']} flex-grow-1`}>
          <CatHeading variant="title">
            {isSelectedEquipment
              ? t('CHANGE_EQUIPMENT')
              : t('SELECT_EQUIPMENT')}
          </CatHeading>
        </div>
        <div className={styles['equipment-header__searchbar']}>
          <MyEquipmentSearch
            size={btnSize}
            placeholder={t('MEQ_SEARCH_PLACEHOLDER')}
            onSearch={handleSearch}
            {...{
              mobileBreakPoint: 0,
              value: searchValue || ''
            }}
          />
        </div>
        <div className={styles['equipment-header__addbutton']}>
          <AddEquipmentButton size={btnSize} aria-label={btnText}>
            {btnText}
          </AddEquipmentButton>
        </div>
      </div>
    </div>
  );
};

export default MyEquipmentSearchContainer;
